module.exports = __webpack_public_path__ + "img/album18_43.bfabf252.jpg";